import React, {
  ChangeEventHandler,
  FocusEventHandler,
  MouseEventHandler
} from 'react';
import clsx from 'clsx';
import { Input, InputSize } from '../Input/Input';
import { Icon } from '../Icon/Icon';
import { IconActionSearch } from '../../icons/index';
import { IconSize } from '../Icon/iconSize';
import { InputPropsWithoutRef } from '../../common/types';
import { SelectSearchableVariant } from './Select';

export interface SelectSearchInputProps
  extends Omit<InputPropsWithoutRef, 'size' | 'onClick'> {
  type?: keyof typeof SelectSearchableVariant;
  placeholder?: string;
  inputRef?: React.Ref<HTMLInputElement>;
  disabled?: boolean;
  value?: string;
  onChange?: ChangeEventHandler;
  onFocus?: FocusEventHandler;
  onBlur?: FocusEventHandler;
  onClick?: MouseEventHandler<HTMLDivElement | HTMLInputElement>;
}

export function SelectSearchInput({
  type = SelectSearchableVariant.inline,
  disabled,
  className,
  inputRef,
  ...props
}: SelectSearchInputProps) {
  if (type === SelectSearchableVariant.dropdown) {
    return (
      <Input
        inputRef={inputRef}
        size={InputSize.medium}
        right={
          <Icon
            className="hse-Select__searchIcon"
            icon={IconActionSearch}
            size={IconSize.medium}
          />
        }
        tabIndex={!disabled ? 0 : -1}
        className={clsx('hse-Select__searchInput', className)}
        {...props}
      />
    );
  }

  return (
    <input
      ref={inputRef}
      className={clsx(
        'hse-Select__searchInput',
        'hse-Select__searchInput_noBorder',
        'hse-Select__searchInput_inline',
        className
      )}
      tabIndex={!disabled ? 0 : -1}
      {...props}
    />
  );
}
